import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { getExpressParams, putExpress } from '../../../service/api';
import md5 from 'md5';
import { useHistory } from 'react-router-dom';
import AdminUserEditMain from '../../presentation/section/admin-page/AdminUserEditMain';
import { USER_ROLE_SET } from '../../../config/UserRoleSet';

const leftPad = (value) => {
  if (value >= 10) {
    return value;
  }

  return `0${value}`;
}

const dateToString = (date, delimiter) => {
  const year = date.getFullYear();
  const month = leftPad(date.getMonth() + 1);
  const day = leftPad(date.getDate());

  return [year, month, day].join(delimiter); 
}

const toRoleSelectList = () => {
  let option = [];
  USER_ROLE_SET.forEach((item)=>{
    if(item.role == 'ROLE_USER'){

    }
    else{
      option.push({
        value: item.role,
        label: item.name,
      })
    }
  })

  return option;
}


const AdminUserEdit = (props) => {
  const history = useHistory();
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfimPassword] = useState('');
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [role, setRole] = useState(USER_ROLE_SET[0].role);
  const [expireDate, setExpireDate] = useState(new Date());
  const [company, setCompany] = useState('');
  const [saveTooltip, setSaveTooltip] = useState('test')
  const [bio, setBio] = useState('');
  const [defaultRole, setDefaultRole] = useState(null);
  const [userID, setUserID] = useState(null);
  const [passwordChange, setPasswordChange] = useState(false);
  const roleSelectOption = toRoleSelectList();

  const selectRole = (e) => {
    if(e) {
      setRole(e.value);
    }
    else {
      setRole(null);
    }
  }

  useEffect(() => {
    if(props.currentRole != 'ROLE_ADMIN'){
      history.goBack();
    }
    setUserID(props.match.params.userID)
    getExpressParams('/account/info/userid', {
      userID: props.match.params.userID
    }, (response) => {
      if(response.data.role == 'ROLE_USER'){
        setRole('ROLE_USER_01');
        setDefaultRole({
          value: 'ROLE_USER_01', 
          label: USER_ROLE_SET.find(item=>item.role=='ROLE_USER_01').name
        })
      }
      else{
        setRole(response.data.role);
        setDefaultRole({
          value: response.data.role, 
          label: USER_ROLE_SET.find(item=>item.role==response.data.role).name
        })
      }
      setUsername(response.data.name);
      setEmail(response.data.email);
      setCompany(response.data.company);
      setExpireDate(new Date(response.data.expireDate.toString().replace(/(\d{4})(\d{2})(\d{2})/g, '$1-$2-$3')))
    })
  }, [])

  useEffect(() => {
    setNewPassword('');
    setConfimPassword('');
  }, [passwordChange])

  const handlePasswordChange = () => {
    setPasswordChange(!passwordChange);
  }

  const handleSave = () => {
    if (passwordChange) {
      const hashedNewPassword = md5(newPassword+"{"+email+"}");

      if(newPassword==confirmPassword && newPassword.length >= 8){
        putExpress('/account/info/password/admin', {
          // bio: bio,
          userID: userID,
          email: email,
          username: username,
          password: hashedNewPassword,
          role: role,
          company: company,
          expireDate: dateToString(expireDate,'-'),
          // macAddress: null
        }, (response) => {
          if (response.data.code == 3) {
            setSaveTooltip('중복된 E-mail이 존재합니다.')
          }
          else if (response.data.code == 0) {
            // setEmail('');
            // setUsername('');
            setNewPassword('');
            setConfimPassword('');
            // setRole(USER_ROLE_SET[0].role);
            // setCompany('');
            // setExpireDate(new Date());
            setSaveTooltip('계정 정보가 수정되었습니다.')
          }
        })
      }
      else if (newPassword!=confirmPassword) {
        setSaveTooltip('패스워드가 일치하지 않습니다.')
      }
      else if (newPassword.length < 8) {
        setSaveTooltip('패스워드가 8자 미만입니다.')
      }
    }
    else{
      putExpress('/account/info/admin', {
        // bio: bio,
        userID: userID,
        email: email,
        username: username,
        role: role,
        company: company,
        expireDate: dateToString(expireDate,'-'),
        // macAddress: null
      }, (response) => {
        if (response.data.code == 3) {
          setSaveTooltip('중복된 E-mail이 존재합니다.')
        }
        else if (response.data.code == 0) {
          // setEmail('');
          // setUsername('');
          setNewPassword('');
          setConfimPassword('');
          // setRole(USER_ROLE_SET[0].role);
          // setCompany('');
          // setExpireDate(new Date());
          setSaveTooltip('계정 정보가 수정되었습니다.')
        }
      })
    }
  }

  const handleDate = (selectedDate) => {
    setExpireDate(selectedDate)
  }

  const handleCompany = (event) => {
    setCompany(event.target.value)
  }

  const handleEmail = (event) => {
    setEmail(event.target.value)
  }

  const handleConfirmPassword = (event) => {
    setConfimPassword(event.target.value)
  }

  const handleNewPassword = (event) => {
    setNewPassword(event.target.value);
  }

  const handleUsername = (event) => {
    setUsername(event.target.value)
  }


  return (
    <AdminUserEditMain handleSave={handleSave} handleDate={handleDate} expireDate={expireDate} saveTooltip={saveTooltip}
    company={company} handleCompany={handleCompany} email={email} handleEmail={handleEmail}
    confirmPassword={confirmPassword} handleConfirmPassword={handleConfirmPassword}
    newPassword={newPassword} handleNewPassword={handleNewPassword} username={username} handleUsername={handleUsername}
    roleSelectOption={roleSelectOption} defaultRole={defaultRole} selectRole={selectRole}
    userID={userID} passwordChange={passwordChange} handlePasswordChange={handlePasswordChange}
    />
  )
}

const mapStateToProps = (state) => ({
  currentUser: state.AuthManager.status.currentUser,
  currentRole : state.AuthManager.status.currentRole
})

export default connect(mapStateToProps) (AdminUserEdit);